import type { SourcingEvent } from '../../types';

interface ItemsTabProps {readonly event: SourcingEvent;}

export function ItemsTab({ event }: ItemsTabProps) {
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h3 className="font-semibold text-gray-900">Line Items ({event.lines.length})</h3>
      </div>
      <div className="overflow-hidden rounded-lg border">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500">
                Item
              </th>
              <th className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500">
                SKU
              </th>
              <th className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500">
                Category
              </th>
              <th className="px-4 py-3 text-right text-xs font-medium uppercase tracking-wider text-gray-500">
                Quantity
              </th>
              <th className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500">
                Specifications
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200 bg-white">
            {event.lines.map((line) => (
              <tr key={line.lineId} className="hover:bg-gray-50">
                <td className="whitespace-nowrap px-4 py-3">
                  <p className="font-medium text-gray-900">{line.itemName}</p>
                </td>
                <td className="whitespace-nowrap px-4 py-3 text-sm text-gray-500">{line.sku}</td>
                <td className="whitespace-nowrap px-4 py-3 text-sm text-gray-500">
                  {line.category}
                </td>
                <td className="whitespace-nowrap px-4 py-3 text-right text-sm">
                  {line.quantity} {line.unit}
                </td>
                <td className="px-4 py-3 text-sm text-gray-500">{line.specifications ?? '-'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
